import { useMemo } from "react";
import { useSelector } from 'react-redux';
import { getAuth } from "../slices/authSlice";

const useAccess = (_listAccess) =>
{

  const Auth = useSelector(getAuth);

  

  const access = useMemo(() => {

    let current = {
      canRead: false,
      canWrite: false
    };

    if (Auth.User && Auth.User.role)
    {
      if (Auth.User.role.isAdmin)
      {
        current.canRead = true;
        current.canWrite = true;
      }

      Auth.User.role.access.forEach(a => {

        if (_listAccess.some(acc => acc == a.code)){
          current.canRead = true;
          current.canWrite = current.canWrite ? true : a.canWrite;
        }

      });

    }


    return current;

  }, [Auth, _listAccess]);

  return access;

}

export default useAccess;
